import { render, staticRenderFns } from "./ZOnaylama.vue?vue&type=template&id=565b4b9c&"
import script from "./ZOnaylama.vue?vue&type=script&lang=js&"
export * from "./ZOnaylama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports